import { createContext, createElement, type PropsWithChildren, type ReactElement, useContext } from 'react';

const EventbriteExternalTicketingContext = createContext(false);

export function EventbriteExternalTicketingProvider({
    enabled,
    children,
}: PropsWithChildren<{ enabled: boolean }>): ReactElement {
    return createElement(EventbriteExternalTicketingContext.Provider, { value: enabled }, children);
}

export function useEventbriteExternalTicketing(): boolean {
    return useContext(EventbriteExternalTicketingContext);
}
